import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SampleBadgeProps {
    className?: string
}

interface SampleNoticeProps {
    kind: 'case study' | 'lab entry' | 'article'
    file: string
    className?: string
}

/** Marks demo content in listings so it is never mistaken for real work. */
export const SampleBadge: FC<SampleBadgeProps> = ({ className }): ReactNode => {
    return (
        <span
            title='Sample content, replace it with your own'
            className={cn(
                'inline-flex items-center rounded-sm border border-dashed border-border-strong px-1.5 font-mono text-[0.625rem] uppercase leading-5 tracking-label text-muted-foreground',
                className
            )}
        >
            Sample
        </span>
    )
}

/** Banner at the top of a demo entry, pointing at the file to replace. */
const SampleNotice: FC<SampleNoticeProps> = ({ kind, file, className }): ReactNode => {
    return (
        <aside
            aria-label='Sample content notice'
            className={cn('flex flex-col gap-1 border border-dashed border-border-strong bg-surface px-4 py-3 sm:flex-row sm:items-baseline sm:gap-3', className)}
        >
            <span className='font-mono text-label uppercase text-brand'>Sample {kind}</span>

            <p className='text-[0.875rem] leading-relaxed text-muted-foreground'>
                Demo content that shows the layout. Nothing here describes completed work or real results.
                Replace it in <code className='font-mono text-[0.8125rem] text-foreground'>{file}</code>.
            </p>
        </aside>
    )
}

export default SampleNotice
